import NoteBoard from './NoteBoard';
import NoteBoardWrapper from './NoteBoardWrapper';

export { NoteBoard, NoteBoardWrapper };
export default NoteBoard;
